import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { PRODUCT, guaranteeSteps } from '../data/poolContent';
export function GuaranteeSection() {
  return <section className="w-full bg-abyss-900 py-14 sm:py-20" aria-labelledby="guarantee-title" data-id="element-143" data-mp="4xcmr0936qdn">
      <div className="mx-auto grid max-w-4xl items-center gap-10 px-5 sm:grid-cols-[auto_1fr] sm:gap-12" data-id="element-144" data-mp="9wfs6lszaym5">
        <div className="mx-auto flex h-40 w-40 flex-col items-center justify-center rounded-full border-2 border-gold/60 text-center" data-id="element-145" data-mp="er365qqcwamh">
          <ShieldCheckIcon className="h-7 w-7 text-gold" strokeWidth={1.5} aria-hidden="true" data-id="element-146" data-mp="ntceqb22dtx8" />
          <p className="mt-1 font-display text-[2.4rem] font-bold leading-none text-frost-50" data-id="element-147" data-mp="skcdlluqum2d">7-Day</p>
          <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-gold" data-id="element-148" data-mp="xk725ir1qzk9">Guarantee</p>
        </div>

        <div className="text-center sm:text-left" data-id="element-149" data-mp="12k365hzquqzt">
          <h2 id="guarantee-title" className="font-display text-[2rem] font-bold uppercase leading-none text-frost-50 sm:text-[2.6rem]" data-id="element-150" data-mp="17i4ou1t9coar">
            Try {PRODUCT} for 7 days
          </h2>
          <ul className="mt-5 space-y-1" data-id="element-151" data-mp="20savgcpzdbpn">
            {guaranteeSteps.map(s => <li key={s} className="text-[15px] leading-snug text-frost-100" data-id="element-152" data-mp="1vthgsgyyjenw">
                {s}
              </li>)}
          </ul>
          <p className="mt-4 text-[14.5px] leading-relaxed text-body" data-id="element-153" data-mp="1rth0srw7mveq">
            If it isn’t what you expected, request a refund within 7 days according to the store
            refund policy.
          </p>
        </div>
      </div>
    </section>;
}